import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-minus-thin",
  "use": "icon-minus-thin-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill-rule=\"evenodd\" viewBox=\"0 0 24 24\" id=\"icon-minus-thin\"><path d=\"M0 12v1h23v-1h-23z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol